<template>
  <div class="tinymce-editor">
    <editor v-model="col.data" :id="getId()" :init="init" :disabled="disabled" @onClick="onClick">
    </editor>
  </div>
</template>
<script>
import tinymce from 'tinymce/tinymce'
import Editor from '@tinymce/tinymce-vue'
import defaultConfig from './config'
import Url from "@/api/url"
export default {
  components: {
    Editor
  },
  props: {
    col: true,
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
  },
  mounted() {
    tinymce.init({})
  },
  data () {
    return {
      defaultUploadUrl: Url.img.upload,
      uploadHeaders: {'Content-Type': 'multipart/form-data'},
      init: Object.assign(this.col.action || defaultConfig,this.col.config?this.col.config:{},{
        images_upload_handler:(blobInfo, success, failure) => {
          const maxSize = 2
          const blob = blobInfo.blob()
          if (blob.size / 1024 / 1024 > maxSize) {
            failure('图片大小不能超过' + maxSize + 'MB')
            return
          }
          const formData = new FormData()
          formData.append('file', blob, blobInfo.fileName)
          this.$axios.post(this.defaultUploadUrl, formData, { headers:this.uploadHeaders}).then(res => {
            console.log(res);
            if (res.code == 0) success(res.result);
            else failure('文件上传失败，请重试');
          }).catch(res => {
            failure('文件上传失败，请重试');
          })
          /*upload(formData).then(res => {
            success(res.data.fileUrl)
          }).catch(() => {
            failure('文件上传失败，请重试')
          })*/
        }
      }),
    }
  },
  methods: {
    getId () {
      // 这个id一定要写，否则会出现莫名其妙的问题。
      return 'tinymce-' + Date.now() + Math.floor(Math.random() * 1000)
    },
    // 添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
    // 需要什么事件可以自己增加
    onClick (e) {
      this.$emit('onClick', e, tinymce)
    },
    // 可以添加一些自己的自定义事件，如清空内容
    clear () {
      this.col.data = '';
    }
  },
  watch: {
    value (newValue) {
      this.col.data = newValue
    },
    /*myValue (newValue) {
      this.$emit('input', newValue)
    }*/
  }
}
</script>
<style>
.tox-tinymce-aux{
  z-index: 999999999!important;
}
</style>
